<template>
  <div class="modal fade" id="operatorErrorModal" tabindex="-1" aria-labelledby="operatorErrorModal" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content" v-if="!loading">
        <div class="modal-header p-5">
          <h5 class="modal-title" id="operatorErrorLabel">
            Ошибка оператора
          </h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <template v-if="!loading">
          <div class="modal-body p-5" v-if="id">
            <template v-if="!success">
              <div class="mb-3">
                <div v-if="step === 1 || step === 2" class="text-gray-500 fw-semibold fs-6 mb-3 text-center">Код был отправлен на <b>{{ this.sendPhone }}</b></div>
                <div class="w-275px m-auto">
                  <input-mask-field
                      v-if="step === 1 || step === 2"
                      v-model="code"
                      id="form.code"
                      name="form_code"
                      :required="true"
                      :mb="5"
                      placeholder="Код"
                      mask="####"
                      type="text"
                  />
                  <button v-if="step === 0" class="btn btn-primary btn-sm btn-block" @click="sendCode">
                    <span class="indicator-label">Отправить код</span>
                  </button>
                  <button v-if="step === 1" class="btn btn-warning btn-sm btn-block" :disabled="this.timer !== 0" @click="sendCode">
                    <span class="indicator-label">Повторно отправить код <span v-if="this.timer > 0"> через {{ this.timer }} сек.</span></span>
                  </button>
                  <button v-if="step === 2" class="btn btn-primary btn-sm btn-block" @click="rescind(this.id)">
                    <span class="indicator-label">Подтвердить код</span>
                  </button>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="alert alert-primary d-flex align-items-center p-5 mb-10">
                <i class="ki-duotone ki-shield-tick fs-2hx text-primary me-4">
                  <span class="path1"></span>
                  <span class="path2"></span>
                </i>
                <div class="d-flex flex-column">
                  <h4 class="mb-1 text-primary">Процесс по <b v-html="id"></b> успешно завершен</h4>
                </div>
              </div>
            </template>
          </div>
          <div class="modal-body p-5" v-else>
            <div class="text-center">
              Параметр <b class="text-danger">ID</b> не указан!
            </div>
          </div>
        </template>
        <div class="modal-footer p-2 justify-content-center">
          <button type="button" class="btn btn-sm btn-secondary" data-bs-dismiss="modal">Отменить</button>
        </div>
      </div>
      <div class="modal-content" v-else>
        <loader-full :text="loadingText" style="min-height: 323px"/>
      </div>
    </div>
  </div>
</template>
<script>
import InputMaskField from '@/components/Fields/InputMaskField'
import LoaderFull     from '@/components/Main/LoaderFull'
import axios          from 'axios'

export default {
  name: 'OperatorErrorModal',
  components: {LoaderFull, InputMaskField},
  props: {
    id:       null,
  },
  data() {
    return {
      code:        '',
      step:        0,
      timer:       0,
      interval:    null,
      sendPhone:   '',
      loadingText: '',
      loading:     false,
      success:     false
    }
  },
  computed: {
    getUser() {
      return this.$store.state.user
    },
  },
  methods: {
    countDownTimer () {
      this.interval = setInterval(() => {
        if (this.timer === 0) {
          clearInterval(this.interval)
          this.timer = 0
        } else {
          this.timer = this.timer - 1
        }
      }, 1000)
    },
    sendCode() {
      this.loading = true
      this.loadingText = 'Отправляем код'
      axios.post('/api/contracts/process-otp', { id: this.id, type:2 })
          .then(res => {
            if (res.data.result) {
              this.timer = 90
              this.countDownTimer()
              if (res.data.value) this.sendPhone = res.data.value
              this.step = 1
            } else
              this.$notifyError(res.data)
          })
          .catch(err => {
            this.$notifyError(err)
          })
          .finally(() => {
            this.loading = false
            this.loadingText = ''
          })
    },
    rescind(id) {
      this.loading      = true
      this.loadingText  = 'Оформление "Ошибка оператора"'
      const headers     = {id: id, code: this.code, type: 2, isRescind:true}
      axios.post('/api/contracts/rescind', headers)
          .then(res  => {
            if (res.data.result) {
              this.$notifySuccess(res.data)
              this.$emit('reload', true)
              this.modalHidden()
            } else {
              this.$notifyError(res.data)
              this.step = 1
            }
          })
          .catch(err => {
            const error = err.hasOwnProperty('response') ? err.response.data.message : err.message
            this.$notifyError(error)
          })
          .finally(() => {
            this.loading = false
            this.loadingText = ''
          })
    },
    modalHidden() {
      const myModalEl = document.getElementById('operatorErrorModal');
      const modal     = bootstrap.Modal.getInstance(myModalEl);
      modal.hide();
    }
  },
  watch: {
    hash: {
      deep: true,
      handler (newValue) {
        console.log(newValue/2)
      }
    },
    code: {
      deep: true,
      handler: function(newValue) {
        this.step = newValue.length === 4 ? 2 : 1
      }
    },
  }
}
</script>
<style scoped>

</style>